export const localesMap: {
	[name: string]: string;
} = {
	'ar-SA': 'ar-SA',
	'cs-CZ': 'cs-CZ',
	'da-DK': 'da-DK',
	de: 'de-DE',
	'de-DE': 'de-DE',
	'el-GR': 'el-GR',
	en: 'en',
	'en-AU': 'en-AU',
	'en-CA': 'en-CA',
	'en-GB': 'en-GB',
	'en-US': 'en',
	es: 'es-ES',
	'es-ES': 'es-ES',
	'es-US': 'es-MX',
	'es-MX': 'es-MX',
	'fi-FI': 'fi-FI',
	'fr-CA': 'fr-CA',
	'fr-FR': 'fr-FR',
	fr: 'fr-FR',
	'he-IL': 'he-IL',
	'hi-IN': 'hi-IN',
	// hr: 'hr',
	'hu-HU': 'hu-HU',
	'id-ID': 'id-ID',
	'it-IT': 'it-IT',
	'ja-JP': 'ja-JP',
	'ko-KR': 'ko-KR',
	'ms-MY': 'ms-MY',
	'nb-NO': 'nb-NO',
	'nl-NL': 'nl-NL',
	'pl-PL': 'pl-PL',
	'pt-BR': 'pt-BR',
	'pt-PT': 'pt-PT',
	// 'ro': 'ro',
	'ru-RU': 'ru-RU',
	'sk-SK': 'sk-SK',
	'sv-SE': 'sv-SE',
	'th-TH': 'th-TH',
	'tl-PH': 'tl-PH',
	'tr-TR': 'tr-TR',
	'vi-VN': 'vi-VN',
	XXXX: 'XXXX',
	'zh-CN': 'zh-CN',
	'zh-Hant-HK': 'zh-HK',
	'zh-Hant-TW': 'zh-HK',
	'zh-HK': 'zh-HK',
	'zh-TW': 'zh-HK',
	'zh-SG': 'zh-CN',
};

export const localeToDirection = (locale: string): 'RTL' | 'LTR' => {
	if (locale.startsWith('ar') || locale.startsWith('he')) {
		return 'RTL';
	}
	return 'LTR';
};
